// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Card,
//   CardContent,
//   Grid,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Chip,
//   CircularProgress,
// } from "@mui/material";
// import axiosInstance from "../../utils/axios";
// import { toast } from "react-toastify";

// export default function OwnerCommission() {
//   const [data, setData] = useState({
//     currentCommissionRate: 0,
//     summary: {
//       totalOrders: 0,
//       totalOrderRevenue: 0,
//       totalPlatformCommission: 0,
//       totalRestaurantNet: 0,
//     },
//     orders: [],
//   });
//   const [loading, setLoading] = useState(true);

//   const fetchReport = async () => {
//     setLoading(true);
//     try {
//       const res = await axiosInstance.get("/api/orders/commission-report");
//       setData(res.data);
//     } catch (err) {
//       toast.error("Failed to load commission report");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchReport();
//   }, []);

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" py={8}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <Box p={3}>
//       <Box mb={3}>
//         <Typography variant="h5" fontWeight="bold">
//           Commission & Earnings Breakdown
//         </Typography>
//         <Typography variant="body2" color="text.secondary">
//           Order-wise breakdown of total amount, RestaurantWala commission, and your net earnings
//         </Typography>
//       </Box>

//       {/* Top 4 Summary Cards */}
//       <Grid container spacing={3} mb={4}>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card sx={{ borderLeft: "5px solid #6366f1" }}>
//             <CardContent>
//               <Typography variant="caption" color="text.secondary" fontWeight="bold">
//                 ASSIGNED COMMISSION RATE
//               </Typography>
//               <Typography variant="h4" fontWeight="bold" color="#6366f1" mt={1}>
//                 {data.currentCommissionRate}%
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card sx={{ borderLeft: "5px solid #0284c7" }}>
//             <CardContent>
//               <Typography variant="caption" color="text.secondary" fontWeight="bold">
//                 TOTAL ORDERS AMOUNT
//               </Typography>
//               <Typography variant="h4" fontWeight="bold" color="#0284c7" mt={1}>
//                 ₹{data.summary.totalOrderRevenue}
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card sx={{ borderLeft: "5px solid #dc2626" }}>
//             <CardContent>
//               <Typography variant="caption" color="text.secondary" fontWeight="bold">
//                 RESTAURANTWALA COMMISSION
//               </Typography>
//               <Typography variant="h4" fontWeight="bold" color="error.main" mt={1}>
//                 ₹{data.summary.totalPlatformCommission}
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card sx={{ borderLeft: "5px solid #16a34a", bgcolor: "#f0fdf4" }}>
//             <CardContent>
//               <Typography variant="caption" color="text.secondary" fontWeight="bold">
//                 NET RESTAURANT EARNING (AAPKE PAAS)
//               </Typography>
//               <Typography variant="h4" fontWeight="bold" color="success.main" mt={1}>
//                 ₹{data.summary.totalRestaurantNet}
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>

//       {/* Order-wise Commission Table */}
//       <TableContainer component={Paper} elevation={2}>
//         <Table>
//           <TableHead sx={{ bgcolor: "grey.100" }}>
//             <TableRow>
//               <TableCell><strong>Order ID & Date</strong></TableCell>
//               <TableCell><strong>Customer</strong></TableCell>
//               <TableCell><strong>Total Order Amount</strong></TableCell>
//               <TableCell><strong>Commission %</strong></TableCell>
//               <TableCell><strong>RestaurantWala Share</strong></TableCell>
//               <TableCell><strong>Restaurant Share (Aapke Paas)</strong></TableCell>
//               <TableCell><strong>Status</strong></TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {data.orders.map((order) => (
//               <TableRow key={order._id} hover>
//                 <TableCell>
//                   <Typography fontWeight="bold" color="primary">
//                     #{order._id.slice(-6).toUpperCase()}
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     {new Date(order.createdAt).toLocaleString("en-IN")}
//                   </Typography>
//                 </TableCell>

//                 <TableCell>{order.customerName}</TableCell>

//                 <TableCell>
//                   <Typography fontWeight="bold">₹{order.totalAmount}</Typography>
//                 </TableCell>

//                 <TableCell>
//                   <Chip label={`${order.commissionRate}%`} size="small" color="secondary" variant="outlined" />
//                 </TableCell>

//                 <TableCell>
//                   <Typography fontWeight="bold" color="error.main">
//                     - ₹{order.commissionAmount}
//                   </Typography>
//                 </TableCell>

//                 <TableCell>
//                   <Typography variant="subtitle1" fontWeight="bold" color="success.main">
//                     ₹{order.restaurantNetAmount}
//                   </Typography>
//                 </TableCell>

//                 <TableCell>
//                   <Chip label={order.status} size="small" />
//                 </TableCell>
//               </TableRow>
//             ))}

//             {data.orders.length === 0 && (
//               <TableRow>
//                 <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
//                   No orders found.
//                 </TableCell>
//               </TableRow>
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Box>
//   );
// }

import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Button,
  CircularProgress,
  TextField,
  Divider,
} from "@mui/material";
import {
  Payment,
  CheckCircle,
  HourglassEmpty,
  ContentCopy,
  EventRepeat,
} from "@mui/icons-material";
import QRCode from "react-qr-code";
import axiosInstance from "../../utils/axios";
import { toast } from "react-toastify";

export default function OwnerCommission() {
  const [data, setData] = useState({
    currentCommissionRate: 0,
    adminPaymentInfo: {
      upiId: "restaurantwala@ybl",
      phonePeNumber: "9876543210",
      accountName: "RestaurantWala Official",
    },
    summary: {
      totalOrders: 0,
      totalOrderRevenue: 0,
      totalPlatformCommission: 0,
      totalRestaurantNet: 0,
      unsettledCommission: 0,
      underReviewCommission: 0,
      paidCommission: 0,
      unsettledOrdersCount: 0,
      last7DaysCommission: 0,
    },
    orders: [],
  });
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [utrNumber, setUtrNumber] = useState("");

  const fetchReport = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/api/orders/commission-report");
      setData(res.data);
    } catch (err) {
      toast.error("Failed to load commission report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  const handleCopy = (text, label) => {
    navigator.clipboard.writeText(text);
    toast.success(`${label} copied!`);
  };

  const handlePayToRestaurantWala = async () => {
    if (data.summary.unsettledCommission <= 0) {
      toast.info("No pending commission due to pay!");
      return;
    }

    // 🛡️ Safety check (in case button disabled fails somehow)
    if (utrNumber.length !== 12) {
      toast.error("Please enter a valid 12-digit UTR / Transaction ID");
      return;
    }

    setSubmitting(true);
    try {
      const res = await axiosInstance.put("/api/orders/commission-pay", {
        utrNumber,
      });
      toast.success(res.data.message);
      setUtrNumber("");
      fetchReport();
    } catch (err) {
      toast.error(err.response?.data?.message || "Payment request failed");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={8}>
        <CircularProgress />
      </Box>
    );
  }

  // UPI Deep Link for QR Code
  const upiString = `upi://pay?pa=${data.adminPaymentInfo?.upiId}&pn=${encodeURIComponent(
    data.adminPaymentInfo?.accountName || "RestaurantWala",
  )}&am=${data.summary.unsettledCommission || 0}&cu=INR`;

  return (
    <Box p={3}>
      <Box
        mb={3}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={2}
      >
        <Box>
          <Typography variant="h5" fontWeight="bold">
            Commission & Earnings Breakdown (7-Day Settlement Cycle)
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Pay RestaurantWala commission every 7 days and track verified order
            settlements
          </Typography>
        </Box>
        <Chip
          icon={<EventRepeat />}
          label="Settlement Cycle: Every 7 Days"
          color="primary"
          variant="outlined"
          sx={{ fontWeight: "bold" }}
        />
      </Box>

      {/* ── TOP 4 SUMMARY CARDS ── */}
      <Grid container spacing={3} mb={4}>
        <Grid item size={{xs:12, sm:6, md:3}}>
          <Card sx={{ borderLeft: "5px solid #6366f1" }}>
            <CardContent>
              <Typography
                variant="caption"
                color="text.secondary"
                fontWeight="bold"
              >
                ASSIGNED COMMISSION RATE
              </Typography>
              <Typography variant="h4" fontWeight="bold" color="#6366f1" mt={1}>
                {data.currentCommissionRate}%
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item size={{xs:12, sm:6, md:3}}>
          <Card sx={{ borderLeft: "5px solid #0284c7" }}>
            <CardContent>
              <Typography
                variant="caption"
                color="text.secondary"
                fontWeight="bold"
              >
                TOTAL ORDERS AMOUNT
              </Typography>
              <Typography variant="h4" fontWeight="bold" color="#0284c7" mt={1}>
                ₹{data.summary.totalOrderRevenue}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item size={{xs:12, sm:6, md:3}}>
          <Card sx={{ borderLeft: "5px solid #dc2626" }}>
            <CardContent>
              <Typography
                variant="caption"
                color="text.secondary"
                fontWeight="bold"
              >
                RESTAURANTWALA COMMISSION
              </Typography>
              <Typography
                variant="h4"
                fontWeight="bold"
                color="error.main"
                mt={1}
              >
                ₹{data.summary.totalPlatformCommission}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item size={{xs:12, sm:6, md:3}}>
          <Card sx={{ borderLeft: "5px solid #16a34a", bgcolor: "#f0fdf4" }}>
            <CardContent>
              <Typography
                variant="caption"
                color="text.secondary"
                fontWeight="bold"
              >
                NET RESTAURANT EARNING (AAPKE PAAS)
              </Typography>
              <Typography
                variant="h4"
                fontWeight="bold"
                color="success.main"
                mt={1}
              >
                ₹{data.summary.totalRestaurantNet}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* ── 7-DAY PAYMENT & SUPER ADMIN UPI / PHONEPE SECTION ── */}
      <Grid container spacing={3} mb={4}>
        {/* Left: Super Admin UPI & PhonePe Card */}
        <Grid item size={{xs:12, sm:6}}>
          <Card
            sx={{
              height: "100%",
              borderRadius: 3,
              border: "1px solid #e2e8f0",
            }}
          >
            <CardContent>
              <Typography
                variant="h6"
                fontWeight="bold"
                color="primary"
                gutterBottom
              >
                Pay To RestaurantWala (Super Admin Details)
              </Typography>
              <Typography variant="body2" color="text.secondary" mb={2}>
                Transfer your 7-day commission via UPI or PhonePe and click "Pay
                to RestaurantWala"
              </Typography>

              <Grid container spacing={2} alignItems="center">
                <Grid item size={{xs:12, sm:7}}>
                  <Box p={1.5} bgcolor="#f8fafc" borderRadius={2} mb={1.5}>
                    <Typography variant="caption" color="text.secondary">
                      Account Name
                    </Typography>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {data.adminPaymentInfo?.accountName}
                    </Typography>
                  </Box>

                  <Box
                    p={1.5}
                    bgcolor="#f8fafc"
                    borderRadius={2}
                    mb={1.5}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Super Admin UPI ID
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        color="primary"
                      >
                        {data.adminPaymentInfo?.upiId}
                      </Typography>
                    </Box>
                    <Button
                      size="small"
                      startIcon={<ContentCopy />}
                      onClick={() =>
                        handleCopy(data.adminPaymentInfo?.upiId, "UPI ID")
                      }
                    >
                      Copy
                    </Button>
                  </Box>

                  <Box
                    p={1.5}
                    bgcolor="#f8fafc"
                    borderRadius={2}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        PhonePe / Mobile Number
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        color="secondary"
                      >
                        {data.adminPaymentInfo?.phonePeNumber}
                      </Typography>
                    </Box>
                    <Button
                      size="small"
                      startIcon={<ContentCopy />}
                      onClick={() =>
                        handleCopy(
                          data.adminPaymentInfo?.phonePeNumber,
                          "PhonePe Number",
                        )
                      }
                    >
                      Copy
                    </Button>
                  </Box>
                </Grid>

                {/* QR Code */}
                <Grid item size={{xs:12, sm:5}} textAlign="center">
                  <Box
                    p={1.5}
                    bgcolor="white"
                    border="1px solid #cbd5e1"
                    borderRadius={2}
                    display="inline-block"
                  >
                    <QRCode value={upiString} size={130} />
                    <Typography
                      variant="caption"
                      display="block"
                      mt={1}
                      fontWeight="bold"
                    >
                      Scan to Pay ₹{data.summary.unsettledCommission}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Right: 7-Day Commission Settlement Action Card */}
        <Grid item size={{xs:12, md:6}}>
          <Card
            sx={{
              height: "100%",
              borderRadius: 3,
              border: "1px solid #e2e8f0",
            }}
          >
            <CardContent>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                7-Day Commission Settlement Status
              </Typography>

              <Grid container spacing={2} my={1}>
                <Grid item size={{xs:4}}>
                  <Box
                    p={1.5}
                    bgcolor="#fef2f2"
                    borderRadius={2}
                    textAlign="center"
                  >
                    <Typography
                      variant="caption"
                      color="error.main"
                      fontWeight="bold"
                    >
                      UNSETTLED DUE
                    </Typography>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color="error.main"
                    >
                      ₹{data.summary.unsettledCommission}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      ({data.summary.unsettledOrdersCount} Orders)
                    </Typography>
                  </Box>
                </Grid>

                <Grid item size={{xs:4}}>
                  <Box
                    p={1.5}
                    bgcolor="#fffbeb"
                    borderRadius={2}
                    textAlign="center"
                  >
                    <Typography
                      variant="caption"
                      color="#d97706"
                      fontWeight="bold"
                    >
                      UNDER REVIEW
                    </Typography>
                    <Typography variant="h5" fontWeight="bold" color="#d97706">
                      ₹{data.summary.underReviewCommission}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Awaiting Admin
                    </Typography>
                  </Box>
                </Grid>

                <Grid item size={{xs:4}}>
                  <Box
                    p={1.5}
                    bgcolor="#f0fdf4"
                    borderRadius={2}
                    textAlign="center"
                  >
                    <Typography
                      variant="caption"
                      color="success.main"
                      fontWeight="bold"
                    >
                      PAID & VERIFIED
                    </Typography>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color="success.main"
                    >
                      ₹{data.summary.paidCommission}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Settled
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              <Divider sx={{ my: 2 }} />

              {/* <TextField
                fullWidth
                size="small"
                label="UTR / Transaction ID"
                placeholder="Enter 12-digit UPI Ref / UTR Number"
                value={utrNumber}
                onChange={(e) => setUtrNumber(e.target.value)}
                sx={{ mb: 2 }}
              />

              <Button
                fullWidth
                variant="contained"
                size="large"
                color="primary"
                startIcon={<Payment />}
                disabled={submitting || data.summary.unsettledCommission <= 0}
                onClick={handlePayToRestaurantWala}
                sx={{ py: 1.4, fontWeight: "bold", borderRadius: 2 }}
              >
                {submitting
                  ? "Submitting..."
                  : data.summary.unsettledCommission > 0
                  ? `Pay to RestaurantWala (₹${data.summary.unsettledCommission})`
                  : data.summary.underReviewCommission > 0
                  ? "Payment Under Review by Super Admin ⏳"
                  : "All Commission Settled ✅"}
              </Button> */}

              <TextField
                fullWidth
                size="small"
                label="UTR / Transaction ID *"
                placeholder="Enter 12-digit UPI Ref / UTR Number"
                value={utrNumber}
                onChange={(e) => {
                  // sirf digits allow karo + max 12
                  const digitsOnly = e.target.value
                    .replace(/\D/g, "")
                    .slice(0, 12);
                  setUtrNumber(digitsOnly);
                }}
                required
                error={utrNumber.length > 0 && utrNumber.length !== 12}
                helperText={
                  utrNumber.length === 0
                    ? "12-digit UTR required to submit payment"
                    : utrNumber.length !== 12
                      ? `${12 - utrNumber.length} digit${12 - utrNumber.length > 1 ? "s" : ""} remaining`
                      : "✓ Valid UTR"
                }
                inputProps={{ inputMode: "numeric", maxLength: 12 }}
                sx={{ mb: 2 }}
              />

              <Button
                fullWidth
                variant="contained"
                size="large"
                color="primary"
                startIcon={<Payment />}
                disabled={
                  submitting ||
                  data.summary.unsettledCommission <= 0 ||
                  utrNumber.length !== 12 // 🆕 UTR must be exactly 12 digits
                }
                onClick={handlePayToRestaurantWala}
                sx={{ py: 1.4, fontWeight: "bold", borderRadius: 2 }}
              >
                {submitting
                  ? "Submitting..."
                  : data.summary.unsettledCommission > 0
                    ? utrNumber.length !== 12
                      ? `Enter 12-digit UTR to Pay (₹${data.summary.unsettledCommission})`
                      : `Pay to RestaurantWala (₹${data.summary.unsettledCommission})`
                    : data.summary.underReviewCommission > 0
                      ? "Payment Under Review by Super Admin ⏳"
                      : "All Commission Settled ✅"}
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* ── ORDER-WISE COMMISSION TABLE (WITH UNDERLINE ON PAID ORDERS) ── */}
      <TableContainer component={Paper} elevation={2}>
        <Table>
          <TableHead sx={{ bgcolor: "grey.100" }}>
            <TableRow>
              <TableCell>
                <strong>#</strong>
              </TableCell>
              <TableCell>
                <strong>Order ID & Date</strong>
              </TableCell>
              <TableCell>
                <strong>Customer</strong>
              </TableCell>
              <TableCell>
                <strong>Total Order Amount</strong>
              </TableCell>
              <TableCell>
                <strong>Commission %</strong>
              </TableCell>
              <TableCell>
                <strong>RestaurantWala Share</strong>
              </TableCell>
              <TableCell>
                <strong>Restaurant Share (Aapke Paas)</strong>
              </TableCell>
              <TableCell align="center">
                <strong>Commission Payment Status</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.orders.map((order, index) => {
              const isPaid = order.settlementStatus === "PAID";
              const isUnderReview = order.settlementStatus === "UNDER_REVIEW";
              const isRejected = order.settlementStatus === "REJECTED";

              // 🔥 UNDERLINE STYLE FOR PAID ORDERS
              // const paidUnderlineStyle = isPaid
              //   ? {
              //       textDecoration: "underline",
              //       textDecorationColor: "#16a34a",
              //       textDecorationThickness: "2.5px",
              //       textUnderlineOffset: "4px",
              //     }
              //   : {};

              return (
                
                <TableRow
                  key={order._id}
                  hover
                  sx={{
                    bgcolor: isPaid
                      ? "#f0fdf4"
                      : isUnderReview
                        ? "#fffbeb"
                        : "inherit",
                  }}
                >
                  <TableCell>{index+1}</TableCell>
                  <TableCell>
                    <Typography
                      fontWeight="bold"
                      color={isPaid ? "success.main" : "primary"}
                      // sx={paidUnderlineStyle}
                    >
                      #{order._id.slice(-6).toUpperCase()}
                    </Typography>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      display="block"
                    >
                      {new Date(order.createdAt).toLocaleString("en-IN")}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                    // sx={paidUnderlineStyle}
                    >
                      {order.customerName}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      fontWeight="bold"
                      // sx={paidUnderlineStyle}
                    >
                      ₹{order.totalAmount}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Chip
                      label={`${order.commissionRate}%`}
                      size="small"
                      color="secondary"
                      variant="outlined"
                    />
                  </TableCell>

                  <TableCell>
                    <Typography
                      fontWeight="bold"
                      color={isPaid ? "success.main" : "error.main"}
                      // sx={paidUnderlineStyle}
                    >
                      ₹{order.commissionAmount}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      color="success.main"
                      // sx={paidUnderlineStyle}
                    >
                      ₹{order.restaurantNetAmount}
                    </Typography>
                  </TableCell>

                  <TableCell align="center">
                    {isPaid && (
                      <Chip
                        icon={<CheckCircle />}
                        label="PAID ✅"
                        color="success"
                        size="small"
                        sx={{ fontWeight: "bold" }}
                      />
                    )}
                    {isUnderReview && (
                      <Chip
                        icon={<HourglassEmpty />}
                        label="UNDER REVIEW ⏳"
                        color="warning"
                        size="small"
                        sx={{ fontWeight: "bold" }}
                      />
                    )}
                    {isRejected && (
                      <Chip
                        label="REJECTED ❌ (Pay Again)"
                        color="error"
                        size="small"
                        sx={{ fontWeight: "bold" }}
                      />
                    )}
                    {order.settlementStatus === "UNSETTLED" && (
                      <Chip
                        label="UNSETTLED (Due)"
                        color="default"
                        size="small"
                        variant="outlined"
                      />
                    )}
                  </TableCell>
                </TableRow>
              );
            })}

            {data.orders.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                  No orders found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
